<template>
  <div class="other">
    <div class="defautwrap" >
      <div class="topnav">
        <img src="https://source.gamedachen.com/h5-source/sdk/fh-icon%402x.png" alt="" @click="backnative">
        游戏充值
      </div>
      <div class="content">
          <div class="orderwrap">
           <div class="order">
             <div> <img src="https://source.gamedachen.com/h5-source/sdk/money-icon%402x.png" alt="">
               订单金额：</div>
             <!-- <div><img src="https://source.gamedachen.com/h5-source/sdk/pay%402x.png" alt="">
             支付金额：</div> -->
           </div>
           <div class="money">
             <p>￥ {{mes.amount|money}}</p>
             <!-- <p>￥ 50.80</p> -->
           </div>
          </div>
      </div>
      <div class="meshods">
        <div class="meshodtop"><span>选择支付方式</span></div>
        <div class="paymethods">
          <div class="item" v-for="(item,index) in arr" :key='item.id' @click="select(item.id,index,item.payName)" :class="activeindex===index?'active':''">
            <img :src="item.payIcon" alt="">
            {{item.payName+'支付'}}
          </div>
        </div>
        <div class="paybtn" @click="paymoney"> {{payName+'支付'}} {{mes.amount|money}} 元</div>
      </div>
    </div>
  </div>
</template>
<script>
import {paydown,getpaymethods,testpaystatus} from '../api/recharge.js'
export default {
  name: 'Other',
  data(){
    return{
      osType:'',
      arr:[],
      activeindex:'',
      mes:{},
      form:{},
      payName:''
    }
  },
  created(){
    // console.log(JSON.parse('{"exInfo" : "rtrt","realAmount" : "100","roleId" : "6839563","phone" : "","amount" : "100","subUserId" : "93892","osType" : "2","code" : "","payType" : "0","goodsName" : "10个游戏道具","roleName" : "lslsl","cpOrderId" : "h897juko1596624622"}'))
    // if(this.$route.query.orderId){
    //   const that = this
    //   var teststatus = function teststatus(){
    //     testpaystatus({orderId:that.$route.query.orderId}).then(res=>{
    //       if(res.data.code == 200){
    //         if(res.data.data.orderStatus>-1){
    //           this.$Message.show(res.data.data.order_msg)
    //         }else if(res.data.data.orderStatus<3){
    //           setTimeout(teststatus,500)
    //         }else if(res.data.data.orderStatus == 3){
    //           if(this.form.osType == 1){
    //             try{
    //               window.SDK.paystate(res.data.data.orderStatus);
    //             }catch{
    //               console.log(error)
    //             }
    //           }else if(this.form.osType == 2){
    //             try{
    //               // const jsonstr = JSON.stringify(item)
    //               window.webkit.messageHandlers.paystate.postMessage(res.data.data.orderStatus);
    //             }catch{
    //               console.log(error)
    //             }
    //           }
    //         }
    //       }
    //     })
    //   }
    //   setTimeout(teststatus,1000)
    // }else
     if(this.$route.query.productId){
      this.form = JSON.parse(JSON.stringify(this.$route.query))
      getpaymethods({productId:this.form.productId,channelId:this.form.channelId}).then(res=>{
        if(res.data.code == 200){
          this.arr = res.data.data
          this.activeindex = 0
          this.form.payChannelType = this.arr[0].id
          this.form.payChannelTyId = this.arr[0].id
          this.payName = this.arr[0].payName
        }
      })
    }
    const that = this
    window.getOrderMes= function(str){
      let mes = str.replace(/[\r\n]/g,"")
      that.mes = JSON.parse(mes)
      that.$set(that.mes,'amount',that.mes.amount)
    }
  },
  mounted(){
    // window.getOrderMes('{"exInfo":"rtrt","realAmount":"100","roleId":"123456789","phone":"13128354126","amount":"100","subUserId":"93947","osType":"2","code":"","payType":"0","goodsName":"10个游戏道具","roleName":"lslsl","cpOrderId":"h8903232322401532"}')
  },
  methods:{
    sendOrderId(num){
      if(this.form.osType == 1){
            try{
              window.SDK.sendOrderId(num);
            }catch{
            }
          }else if(this.form.osType == 2){
            try{
              // const jsonstr = JSON.stringify(item)
              window.webkit.messageHandlers.sendOrderId.postMessage(num);
            }catch{
            }
          }
    },
    select(id,index,name){
      this.activeindex = index
      this.form.payChannelType = id
      this.form.payChannelTyId = id
      this.payName = name
    },
    paymoney(){
      if(this.form&&!this.form.payChannelType){
         this.$Message.show('请选择支付方式')
         return
      }
      let allmes = this.mes
      const form = Object.assign(allmes,this.form)
      paydown(form).then(res=>{
        if(res.data.code == 200){
          if(this.form.payChannelType==2){
            var orderId = res.data.orderId
            this.sendOrderId(orderId)
            setTimeout(() => {
              let content = JSON.parse(res.data.data)
              window.location.href = content.h5Web_url
            }, 100);
          }else if(this.form.payChannelType==5){
              var orderId = res.data.orderId
              this.sendOrderId(orderId)
              setTimeout(() => {
                const div = document.createElement('div')
                div.id = 'alipay'
                div.innerHTML = res.data.data
                document.body.appendChild(div)
                document.querySelector('#alipay').children[0].submit() // 执行后会唤起支付宝
              }, 100);
            }
        }
      })
    },
    backnative(){
      if(this.form.osType == 1){
        try{
          window.SDK.backnative();
        }catch{
          console.log(error)
        }
      }else if(this.form.osType == 2){
        try{
          // const jsonstr = JSON.stringify(item)
          window.webkit.messageHandlers.backnative.postMessage('返回');
        }catch{
          console.log(error)
        }
      }
        // if(bol){
        //   const item = this.selectitem
        //   if(this.form.osType == 1){
        //     try{
        //       window.SDK.callbackUsecoupon();
        //     }catch{
        //       console.log(error)
        //     }
        //   }else if(this.form.osType == 2){
        //     try{
        //       const jsonstr = JSON.stringify(item)
        //       window.webkit.messageHandlers.callbackUsecoupon.postMessage();
        //     }catch{
        //       console.log(error)
        //     }
        //   }
        // }else{
        //   if(this.form.osType == 1){
        //   try{
        //     window.SDK.backys();
        //   }catch{
        //     console.log(error)
        //   }
        //   }else if(this.form.osType == 2){
        //     try{
        //       window.webkit.messageHandlers.backys.postMessage();
        //     }catch{
        //       console.log(error)
        //     }
        //   }
        // }
      },
  },
  filters:{
    money(val){
      if(val){
        return (parseInt(val)/100).toFixed(2)
      }else{
        return '0.00'
      }
    }
  }
}
</script>
<style lang="less" scoped>
  .other{
    font-size: 0.65rem;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    .defautwrap{
      width: 100%;
      height: 100%;
      background: #F7F8F9;
      display: flex;
      flex-direction: column;
      // padding: 0.75rem 1.25rem 0 1.25rem;
      .topnav{
        width: 100%;
        height: 2.25rem;
        background:#fff;
        text-align: center;
        line-height: 2.25rem;
        font-size:0.8rem;
        color:rgba(17,17,17,1);
        position: relative;
        img{
          height: 0.75rem;
          display: block;
          position: absolute;
          left: 0.75rem;
          top: 0;
          bottom: 0;
          margin: auto;
        }
      }
      .content{
        .orderwrap{
          display: flex;
          padding: 0.75rem;
          background: #fff;
          margin-top: 0.25rem;
          margin-bottom: 0.25rem;
          div{
          width: max-content;
          }
          .order{
            margin-right: 0.25rem;
            img{
              height: 0.6rem;
              vertical-align: middle;
            }
          }
          .money{
            font-weight: bold;
          }
        }
      }
      .meshods{
          flex: 1;
          background: #fff;
          padding: 0.75rem;
          .meshodtop{
            display: flex;
            justify-content: space-between;
            span{
              &:first{
                font-size: 0.7rem;
                color: #111111;
              }
              &:last-child{
                font-size: 0.6rem;
                color: #616060;
                .num{
                  color: #417BCA;
                }
              }
            }
          }
          .paymethods{
            display: flex;
            justify-content: space-between;
            padding: 0.5rem 0;
            flex-wrap: wrap;
            .item{
              width: 7.2rem;
              height: 1.75rem;
              background: #F1F2F6;
              border-radius: 0.25rem;
              margin-top: 0.5rem;
              text-align: center;
              line-height: 1.75rem;
              font-size: 0.55rem;
              &.active{
                background: url(https://source.gamedachen.com/h5-source/sdk/wrap%402x.png);
                background-size: cover;
              }
              img{
                height: 0.95rem;
                vertical-align: middle;
              }
            }
          }
          .paybtn{
            margin-top: 0.5rem;
            background: #F5CC40;
            height: 1.9rem;
            border-radius: 1rem;
            text-align: center;
            line-height: 1.9rem;
            color: #070C2D;
            font-size: 0.7rem;
          }
        }
      // .topnav::before{
      //   width: 0.45rem;
      //   height: 0.75rem;
      //   content:'';
      //   display: block;
      //   position: absolute;
      //   left: 0;
      //   top: 0;
      //   bottom: 0;
      //   margin: auto;
      //   background: url(../assets/img/icon.png) no-repeat left center;
      //   background-size:  0.45rem 0.75rem;
      // }
    }
  }
  
</style>
